import React from "react";
import { Link, useLoaderData } from "react-router-dom";

const Details = () => {
  const data = useLoaderData()
  console.log(data);
  const {server ,prname ,technology,fetter,Live,client,image} =data;

  return (
    <div className="max-w-5xl mx-auto">
      <div className="py-10">
        <div className="w-[500px] h-[350px] mx-auto  border-blue-600 border-2 rounded">
          <img src={image} alt="" />
        </div>
      </div>


      <div className="text-2xl mt-16">
        <h1 className="text-3xl my-2 font-semibold">NAME : <span>{prname}</span></h1>
        <div>
          Live Link :
          <a href="#/" className="text-red-500" target="blank">
            {Live}
          </a>
        </div>
        <div>
          Git-Hub Client Link :
          <a href="#/" className="text-red-500" target="blank">
            {client}
          </a>
        </div>
        <div>
          Git-Hub Server Link :
          <a  href={server} className="text-red-500" target="blank">
          {server}
          </a>
        </div>
      </div>

      <div>
        <div className="my-8">
          <span className="text-3xl text-blue-500">Technology : </span>
          <span className="text-xl ">
            {technology}
          </span>
        </div>
      </div>
      <div>
        <div className="mb-8">
          <span className="text-3xl  text-blue-500">Details : </span>
          <span className="text-xl ">
           {fetter}
          </span>
        </div>
      </div>

      <div className="w-32  mx-auto ">
        <Link to="/">
          <button className="btn btn-success w-32 mb-20 mx-auto ">home Page</button>
        </Link>
      </div>
    </div>
  );
};

export default Details;
